/** The small controls modals are assembled from. */

import type { Component, ParentComponent } from 'solid-js';
import styles from './Controls.module.css';

export interface ButtonProps {
  onClick: () => void;
  variant?: 'primary' | 'quiet';
}

export const Button: ParentComponent<ButtonProps> = (props) => (
  <button
    type="button"
    class={[styles.btn, props.variant === 'quiet' ? styles.quiet : styles.primary]}
    onClick={() => props.onClick()}
  >
    {props.children}
  </button>
);

export interface SwitchProps {
  label: string;
  description: string;
  checked: boolean;
  onChange: () => void;
}

export const Switch: Component<SwitchProps> = (props) => (
  <div class={styles.toggleRow} data-testid="toggle-row">
    <div>
      <div class={styles.toggleTitle}>{props.label}</div>
      <div class={styles.toggleSub}>{props.description}</div>
    </div>
    <button
      type="button"
      class={[styles.switch, { [styles.switchOn as string]: props.checked }]}
      role="switch"
      aria-checked={props.checked ? 'true' : 'false'}
      aria-label={props.label}
      onClick={() => props.onChange()}
    />
  </div>
);

export interface FieldProps {
  id: string;
  placeholder: string;
  value: string;
  onInput: (value: string) => void;
}

export const Field: Component<FieldProps> = (props) => (
  <input
    class={styles.input}
    id={props.id}
    placeholder={props.placeholder}
    value={props.value}
    autocomplete="off"
    spellcheck={false}
    onInput={(e) => props.onInput(e.currentTarget.value)}
  />
);

export const Hint: ParentComponent = (props) => <p class={styles.hint}>{props.children}</p>;

export { styles as controlStyles };
